import { Chip } from '@cere/cere-design-system';
import type { Widget } from '@/lib/manifest/types';

interface Props {
  widgets: Widget[];
  activeId: string;
  onSelect: (id: string) => void;
}

/**
 * The widget tab strip, shared by the inline block (WidgetTabs) and the
 * fullscreen overlay (WidgetExpandModal). Renders nothing for a single widget —
 * there's nothing to switch between.
 */
export function WidgetTabStrip({ widgets, activeId, onSelect }: Props) {
  if (widgets.length <= 1) return null;
  return (
    <div role="tablist" className="vault-widget-tabstrip">
      {widgets.map((widget, i) => {
        const selected = widget.id === activeId;
        return (
          <Chip
            key={widget.id}
            role="tab"
            aria-selected={selected}
            clickable
            size="small"
            variant={selected ? 'active' : 'default'}
            onClick={() => onSelect(widget.id)}
            label={widget.name?.trim() || `Widget ${i + 1}`}
          />
        );
      })}
    </div>
  );
}
